import * as React from 'react';
import * as _ from 'lodash';
import * as Model from '../../api/model';
import { Grid, CircularProgress, Paper, Table, TableHead, TableRow, TableCell, TableBody, Toolbar, Typography, Tooltip, IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RedVarietyEditItem from './RedVarietyEditItem';
import RedVarietyAddItem from './RedVarietyAddItem';
import { API } from '../../api';

//#region UI configuration
const strings = {
    title: 'Red Varieties',
    addButton: 'Add',
    idColumn: 'Id',
    nameColumn: 'Name'
};
//#endregion

//#region Props & State
interface RedVarietiesPageProps { }
interface RedVarietiesPageState {
    loading: boolean;
    items: Model.RedVariety[];
    selected: null | number;
    add: boolean;
}

const initialState: RedVarietiesPageState = {
    loading: true,
    items: [],
    selected: null,
    add: false
};
//#endregion

class RedVarietiesPage extends React.Component<RedVarietiesPageProps, RedVarietiesPageState> {

    constructor(props: RedVarietiesPageProps) {
        super(props);

        this.state = initialState;
    }

    // #region Lifecycle
    componentDidMount(): void {
        API.redVariety.list().then(items => {
            this.setState({ loading: false, items });
        });
    }

    render() {
        const { loading, items, selected, add } = this.state;

        return (
            <React.Fragment>
                {loading && <Grid container={true} justify="center">
                    <CircularProgress />
                </Grid>}

                {!loading && <Paper>
                    <Toolbar>
                        <Grid container={true} justify="space-between" alignItems="center">
                            <Grid item={true}>
                                <Typography variant="title">{strings.title}</Typography>
                            </Grid>
                            <Grid item={true}>
                                <Tooltip title={strings.addButton}>
                                    <IconButton onClick={this.onAddClick}>
                                        <AddIcon />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Toolbar>

                    <Table>
                        <colgroup>
                            <col width="15%" />
                            <col width="80%" />
                            <col width="5%" />
                        </colgroup>
                        <TableHead>
                            <TableRow>
                                <TableCell numeric={true}>{strings.idColumn}</TableCell>
                                <TableCell>{strings.nameColumn}</TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {add && <RedVarietyAddItem onItemAdded={this.onItemAdded} onCancelItemAdd={this.onCancelItemAdd} />}
                            {items.map(item => (
                                <RedVarietyEditItem
                                    key={item.id}
                                    item={item}
                                    selected={selected === item.id}
                                    onItemSelected={this.onItemClick}
                                    onItemEdited={this.onItemEdited}
                                    onItemRemoved={this.onItemRemoved}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </Paper>}
            </React.Fragment>
        );
    }
    // #endregion

    // #region Private
    private onAddClick = () => {
        this.setState({ add: true });
    }

    private onItemClick = (id: number) => {
        const { selected } = this.state;
        if (selected !== id) {
            this.setState({ selected: id });
        } else {
            this.setState({ selected: null });
        }
    }

    private onItemRemoved = (id: number) => {
        const { items } = this.state;
        this.setState({ items: items.filter(value => value.id !== id) });
    }

    private onItemEdited = (model: Model.RedVariety) => {
        let { items } = this.state;

        items = items.map(item => {
            if (item.id === model.id) {
                return model;
            } else {
                return item;
            }
        });

        items = _.sortBy(items, [(o: Model.RedVariety) => (o.name)]);

        this.setState({ items, selected: null });
    }

    private onItemAdded = (model: Model.RedVariety) => {
        let { items } = this.state;
        items = items.concat(model);
        items = _.sortBy(items, [(o: Model.RedVariety) => (o.name)]);
        this.setState({ items, add: false });
    }

    private onCancelItemAdd = () => {
        this.setState({ add: false });
    }
    // #endregion
}

export default RedVarietiesPage;



// WEBPACK FOOTER //
// ./src/modules/redVariety/RedVarietiesPage.tsx